import styled from 'styled-components';

const ButtonStyle = styled.div`
	--iconPad: var(--sp3x);
	--sizeIcon: var(--sp3x);
	--padTB: var(--sp3x);
	--padLR: var(--sp6x);
	--radiusButton: var(--sp7x);

	--padSecondaryLR: var(--sp6x);
	--secondaryPadIcon: calc(var(--sp1-5x) + var(--sp0-5x) / 2);
	--sizeIconSecondary: var(--sp5x);

	--tertiaryIconSize: var(--sp4x);
	--distanceIconText: var(--sp1x);

	width: fit-content;
	height: fit-content;

	a,
	button {
		cursor: pointer;
	}
	cursor: pointer;

	&.btn {
		&-secondary {
			--padTB: var(--secondaryPadIcon);
			--padLR: var(--secondaryPadIcon);
			--sizeIcon: var(--sizeIconSecondary);

			background-color: var(--green);
			border-radius: var(--radiusButton);
			padding: var(--padTB);
			overflow: hidden;
			position: relative;
			transition: all var(--trTime) ease-out;

			i {
				color: var(--white);
				font-size: var(--sizeIcon);
				transition: var(--trTime) ease-out;
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
			}

			a,
			button {
				color: var(--white);
			}

			.outside-wrapper-button {
				.inner-text-wrap {
					opacity: 0;
					transition: all var(--trTime) ease-out;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(calc(-50% + calc(var(--padLR) * -1)), -50%);
					white-space: nowrap;
					width: fit-content;
				}
			}

			.content-wrapper {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 0px;
				transition: width var(--trTime) ease-out;

				width: var(--sizeIcon);
				height: var(--sizeIcon);
			}

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						padding-left: var(--padSecondaryLR);
						padding-right: var(--padSecondaryLR);

						.content-wrapper {
							width: var(--sizeText);
						}

						.outside-wrapper-button {
							.inner-text-wrap {
								opacity: 1;
								transform: translate(-50%, -50%);
							}
						}

						i {
							opacity: 0;
							transform: translate(calc(var(--padLR) + var(--sizeText)), -50%);
						}
					}
				}
			}
		}

		&-primary,
		&-primary-icon {
			background-color: var(--green);
			border-radius: var(--radiusButton);
			transition: var(--trTime) ease-out;

			display: flex;
			align-items: center;
			justify-content: center;

			color: var(--white);

			button,
			a {
				padding: var(--padTB) var(--padLR);
				color: var(--white);
				display: flex;
				align-items: center;
				justify-content: center;
			}

			i {
				font-size: var(--sizeIcon);
				aspect-ratio: 1/1;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						background-color: var(--darkGreen1000);
					}
				}
			}
		}

		&-primary-icon {
			button,
			a {
				--padTB: var(--iconPad);
				--padLR: var(--iconPad);
			}
		}

		&-tertiary {
			--sizeIcon: var(--tertiaryIconSize);

			button,
			a {
				font-size: var(--p2);
				font-weight: 600;
				font-family: var(--grotesk_font);
				line-height: var(--lineHeightL);
				color: var(--darkGreen1000);
				display: flex;
				align-items: center;
				justify-content: center;
				gap: var(--distanceIconText);
				transition: var(--trTime) ease-out;
			}

			.text {
				border-bottom: 2px solid var(--darkGreen1000);
				transition: var(--trTime) ease-out;
			}

			i {
				font-size: var(--sizeIcon);
				color: var(--darkGreen1000);
				transition: var(--trTime) ease-out;
			}

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						i,
						button,
						a {
							color: var(--green);
						}
						.text {
							border-bottom: 2px solid var(--green);
						}
					}
				}
			}
		}
	}

	&.primary-green {
		background-color: var(--darkGreen1000);
		border-radius: var(--radiusButton);
		transition: var(--trTime) ease-out;

		display: flex;
		align-items: center;
		justify-content: center;

		color: var(--white);

		button,
		a {
			font-size: var(--p2);
			font-weight: 500;
			font-family: var(--grotesk_font);
			line-height: var(--lineHeightL);
			padding: var(--padTB) var(--padLR);
			border-radius: var(--radiusButton);
			color: var(--white);
			display: flex;
			align-items: center;
			justify-content: center;
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					background-color: var(--green);
				}
			}
		}
	}

	&.disabled {
		opacity: 0.5;
		pointer-events: none;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--padTB: var(--sp2-5x);
		--padLR: var(--sp5x);
		--secondaryPadIcon: var(--sp1-5x);

		--padSecondaryLR: var(--sp5x);
		--sizeIconSecondary: var(--sp4x);

		--iconPad: var(--sp1-5x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--padTB: var(--sp2x);
		--padLR: var(--sp4x);
		--tertiaryIconSize: var(--sp3x);

		--padSecondaryLR: var(--sp4x);
		--sizeIconSecondary: var(--sp3x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--padTB: calc(var(--sp2x) - var(--sp0-5x) / 2);
		--padLR: var(--sp2-5x);
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default ButtonStyle;
